// Relationship Configuration
// Update these dates to match your actual relationship timeline

export const RELATIONSHIP_CONFIG = {
  officialDate: new Date('2022-03-31'),
  
  // Unofficial Start
  unofficialDate: new Date('2021-11-20'), 
  
  milestones: {
    firstMet: new Date('2022-02-07'),
    firstDate: new Date('2022-02-14'),
    firstKiss: new Date('2022-04-05'),
  },
  
  // Display preferences
  preferences: {
    showUnofficialByDefault: true,  // Show both timers on load
    timerStyle: 'full' as 'full' | 'compact',  // Use full or compact timer
  }
};

// Helper function to get a specific milestone
export const getMilestone = (key: keyof typeof RELATIONSHIP_CONFIG.milestones): Date | null => {
  return RELATIONSHIP_CONFIG.milestones[key] || null;
};

// Helper function to calculate days since a date
export const daysSince = (date: Date): number => {
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24));
};

// Helper function to format the relationship duration
export const formatDuration = (date: Date): string => {
  const now = new Date();
  let years = now.getFullYear() - date.getFullYear();
  let months = now.getMonth() - date.getMonth();
  
  if (months < 0) {
    years--;
    months += 12;
  }
  
  const parts = [];
  if (years > 0) parts.push(`${years} ${years === 1 ? 'year' : 'years'}`);
  if (months > 0) parts.push(`${months} ${months === 1 ? 'month' : 'months'}`);
  
  return parts.join(' and ') || 'Just started!';
};